import { IRestaurants, SortByTypes } from './types';

export const state: IRestaurants = {
  restaurants: [],
  categories: [],
  selectedCategory: 0,
  types: { deliver: true, pickup: true },
  ratings: 0,
  costs: { free: false, all: true },
  minDeliveries: { noPreference: false, all: true },
  sortBy: SortByTypes.DISCOUNT,
  search: null,
};
